import {
	AccessToken,
	OktaAuth,
	TokenManagerInterface,
} from "@okta/okta-auth-js";

export const getOktaToken = async () => {
	const authClient: OktaAuth = new OktaAuth({
		issuer: import.meta.env.VITE_APP_ISSUER,
		clientId: import.meta.env.VITE_APP_CLIENT_ID,
	});
	const tokenManager: TokenManagerInterface = authClient.tokenManager;

	const accessToken: AccessToken = (await tokenManager.get(
		"accessToken"
	)) as AccessToken;
	return accessToken?.accessToken;
};
